module.exports = __webpack_public_path__ + "img/20180322_201108-1024x790.3554b3a9.jpg";